export default {
  default: [
    {
      path: "klant/:financeReceiverId/gebruiker/aanmaken",
      name: "financeReceiverAccount.create",
      component: () => import("./views/AccountFormView.vue"),
    },
    {
      path: "klant/:financeReceiverId/vastgoed/gebruiker/aanmaken",
      name: "financeReceiverAccount.create.wizard",
      component: () => import("./views/AccountFormView.vue"),
    },
    {
      path: "klant/:financeReceiverId/gebruiker/:id/wijzigen",
      name: "financeReceiverAccount.edit",
      component: () => import("./views/AccountFormView.vue"),
    },
  ],
};
